import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
// export class UserProfileService {
//     // Default avatar
//     private profileImageSubject = new BehaviorSubject<string>('assets/images/avatar-default.png');

//     profileImage$ = this.profileImageSubject.asObservable();

//     setProfileImage(imageUrl: string) {
//         this.profileImageSubject.next(imageUrl);
//     }

//     // Optionally get current value
//     getProfileImage(): string {
//         return this.profileImageSubject.value;
//     }
// }

export class UserProfileService {
    
    private userSubject = new BehaviorSubject<{
        name: string;
        avatar?: string;
        firstName?: string;
        lastName?: string;
    } | null>(null);
    
    private profileImageSubject = new BehaviorSubject<string>('assets/images/avatar-default.png');
    
    profileImage$ = this.profileImageSubject.asObservable();
    
    setProfileImage(imageUrl: string) {
        this.profileImageSubject.next(imageUrl);
    }
    
    user$ = this.userSubject.asObservable();
    
    setUserDetails(user: {
        name: string;
        avatar?: string;
        firstName?: string;
        lastName?: string;
        // email?: string;
    }) {

        
        const raw = localStorage.getItem('userDetails');
        const userDetails = raw ? JSON.parse(raw) : {};
        
        const newDetails = {
            ...userDetails,
            firstName: user.firstName,
            lastName: user.lastName,
            // email:user.email
        };
         
        localStorage.setItem('userDetails', JSON.stringify(newDetails));
        this.userSubject.next(user);
    }
    
    getUser() {
        return this.userSubject.value;
    }

    clear() {
        this.userSubject.next(null);
        this.profileImageSubject.next('assets/images/avatar-default.png');
    }
}